import React from 'react';
import { oneOf, node, shape, object, func } from 'prop-types';
import { IntlProvider } from 'react-intl';
import { LOCALES } from '../../constants';

export default function Translations({ translations, children }) {
    const { messages, addLocaleData, locale } = translations;

    addLocaleData();

    return (
        <IntlProvider locale={locale} messages={messages}>
            {children}
        </IntlProvider>
    );
}

Translations.propTypes = {
    children: node,
    translations: shape({
        messages: object,
        addLocaleData: func.isRequired,
        locale: oneOf(Object.values(LOCALES)),
    }).isRequired,
};

Translations.defaultProps = {
    children: null,
};
